import { render, staticRenderFns } from "./AthleteVideoStudio.vue?vue&type=template&id=03d410fd&scoped=true&"
import script from "./AthleteVideoStudio.vue?vue&type=script&lang=ts&"
export * from "./AthleteVideoStudio.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteVideoStudio.vue?vue&type=style&index=0&id=03d410fd&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03d410fd",
  null
  
)

export default component.exports